// SuccessToastAddUser.tsx

import React from 'react';
import { Snackbar, Paper, Typography, IconButton, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleIcon from '@mui/icons-material/CheckCircle'; // Using an MUI icon for simplicity

// If you have a custom SVG/image like in the screenshot, use its path:
// const customSuccessIconPath = process.env.PUBLIC_URL + '/icons/your-green-check-circle.svg';

interface SuccessToastAddUserProps {
  open: boolean;
  message: string;
  onClose: () => void;
}

const SuccessToastAddUser: React.FC<SuccessToastAddUserProps> = ({
  open,
  message,
  onClose,
}) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={6000} // Standard duration for snackbars
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 200, // Ensure it's above drawers/modals
        mt: { xs: 2, sm: 3 }, // Margin from top, adjust as needed
      }}
    >
      <Paper
        elevation={3} // A bit of shadow
        sx={{
          display: 'flex',
          alignItems: 'center',
          pl: 1.5,
          pr: 1,
          py: 1,
          borderRadius: '30px', // Highly rounded corners as per screenshot
          backgroundColor: 'common.white',
          minWidth: '300px', // Adjust as needed
          maxWidth: '90%',   // Ensure it doesn't get too wide on small screens
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.08)', // Softer shadow
        }}
      >
        {/* Green Check Circle Icon (MUI version) */}
        <CheckCircleIcon
          sx={{
            color: 'success.main', // MUI green success color
            fontSize: '28px',      // Adjust size
            mr: 1.5,               // Margin right
          }}
        />
        {/* If using a custom image icon:
        <Box
          component="img"
          src={customSuccessIconPath}
          alt="Success"
          sx={{
            width: 28, // Adjust size
            height: 28,
            mr: 1.5,
          }}
        />
        */}

        <Typography
          variant="body2" // body2 is typically 14px
          sx={{
            flexGrow: 1,
            color: 'text.primary',
            fontWeight: 500, // Medium weight
            fontFamily: 'Inter, sans-serif', // Assuming Inter font
            fontSize: '14px', // Explicitly set if needed
          }}
        >
          {message}
        </Typography>

        <IconButton
          aria-label="close"
          color="inherit"
          size="small"
          onClick={onClose}
          sx={{
            color: 'text.secondary',
            ml: 1,
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </Paper>
    </Snackbar>
  );
};

export default SuccessToastAddUser;